import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';

export const MY_DATE_FORMATS = {
    ...MAT_MOMENT_DATE_FORMATS,
    display: {
        ...MAT_MOMENT_DATE_FORMATS.display,
        dateInput: 'DD/MM/YYYY', // Personalize o formato de entrada de data aqui
    },
};
